<template>
  <div class="alert-modal" :class="{ 'alert-modal_large': large }">
    <div class="alert-modal__text">
      {{ message }}
      <slot />
    </div>
    <AppBtn
      class="capitalize alert-modal__btn"
      color="third"
      @click="$modals.close(true)"
    >
      {{ btnText ? btnText : "OK" }}
    </AppBtn>
  </div>
</template>

<script>
export default {
  name: "AlertModal",
  props: {
    message: {
      type: String,
      default: ""
    },
    btnText: {
      type: String,
      default: ""
    },
    large: Boolean
  }
};
</script>

<style lang="scss">
$w-first: 550px;

.modal.app-alert-modal {
  width: 650px;
}

.alert-modal {
  width: 100%;
  display: flex;
  flex-direction: column;

  &__text {
    font-size: 26px;
    text-align: center;
    margin: 0 auto 30px;
    font-weight: bold;
    text-transform: uppercase;

    @media (max-width: $w-first) {
      font-size: 18px;
    }
  }

  &__btn {
    width: 270px;
    height: 50px;
    text-transform: uppercase;
    margin: 0 auto;
    display: flex;
    font-size: 24px;
    max-width: 100%;
  }

  &:first-child {
    margin-right: 40px;
  }

  &_large {
    width: 800px;
  }

  &_large & {
    &__text {
      max-width: 600px;
    }
  }

  @media (max-width: $w-first) {
    &__text {
      font-size: 18px;
    }
  }
}
</style>
